<template>
  <div>
    <form
      ref="form"
      data-url="/evaluator/decision/closureFindingsDecision/update"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row">
        <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
            <h5>Evaluaciones</h5>
          </legend>
        </div>
        <div class="col-12">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">Expediente</th>
                <th scope="col">Tipo</th>
                <th scope="col">Código</th>
                <!-- <th scope="col">Estado</th> -->
                <th scope="col" class="text-center" style="width: 10%">
                  Documento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in evaluations" :key="key">
                <td class="align-middle">
                  {{ value.accreditation_applications.record }}
                </td>
                <td class="align-middle">
                  <p v-if="value.type == 'E'">Evaluación</p>
                  <p v-if="value.type == 'T'">Testificación</p>
                </td>
                <td class="align-middle">{{ value.code }}</td>
                <!-- <td class="align-middle">
                {{ value.status.name }}
                <small class="text-success">(Finalizado)</small>
              </td> -->
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openModal(value)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
            <h5>Documentos</h5>
          </legend>
          <table class="table table-sm table-striped" v-if="docs">
            <thead>
              <tr>
                <th scope="col">TIPO</th>
                <th scope="col">NOMBRE</th>
                <th scope="col">FECHA</th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">Solicitud de acreditación firmada</td>
                <td class="align-middle">
                  {{ docs.request_signed.user.full_name }}
                </td>
                <td class="align-middle">
                  {{ docs.request_signed.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(docs, 'request_signed')"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
              <tr v-if="docs.request_signed">
                <td class="align-middle">
                  Anexos de la Solicitud de Acreditación
                </td>
                <td class="align-middle">
                  {{
                    docs.user
                      ? `${docs.user.first_name} ${docs.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle">
                  {{ docs.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <a
                    class="btn btn-success"
                    :href="`/accreditations/applications/${docs.id}?tab=Anexos`"
                    target="_blank"
                    ><app-icon name="file" /> {{ $t("view") }}</a
                  >
                </td>
              </tr>
              <tr>
                <td class="align-middle">
                  Registro de Ingreso de solicitud de acreditación y acuse
                  recibo
                </td>
                <td class="align-middle">
                  {{ docs.receipt_return_report.user.full_name }}
                </td>
                <td class="align-middle">
                  {{ docs.receipt_return_report.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(docs, 'receipt_return_report')"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12">
          <hr />
          <div class="row">
            <!-- <div class="col-6">
            <div class="form-group">
              <label
                >Informe de la comisión de acreditación:
                <strong class="text-danger">*</strong></label
              >
              <app-input
                type="file"
                :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
                v-if="!inputs.evidence_member_participation"
              />
              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'evidence_member_participation')"
                  v-if="inputs.evidence_member_participation"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal('evidence_member_participation')"
                  v-if="inputs.evidence_member_participation"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div> -->

         <!--   <div class="col-6">
              <div class="form-group">
                <label
                  >Evidencia de participación de los miembros de la comisión:
                  <strong class="text-danger">*</strong></label
                >
                <app-input
                  type="file"
                  :label="
                    inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
                  "
                  v-model="inputs.file_1"
                  :required="true"
                  v-if="!inputs.evidence_member_participation"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs, 'evidence_member_participation')
                    "
                    v-if="inputs.evidence_member_participation"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="confirmed('evidence_member_participation')"
                    v-if="inputs.evidence_member_participation"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div> -->

            <div class="col-6">
              <div class="form-group">
                <label
                  >Informe Técnico de Análisis de Expediente:
                  <strong class="text-danger">*</strong></label
                >
                <app-input
                  type="file"
                  :label="
                    inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
                  "
                  v-model="inputs.file_2"
                  :required="true"
                  v-if="!inputs.technical_file_analysis_report"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs, 'technical_file_analysis_report')
                    "
                    v-if="inputs.technical_file_analysis_report"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="confirmed('technical_file_analysis_report')"
                    v-if="inputs.technical_file_analysis_report"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>

         <!--   <div class="col-6">
              <div class="form-group">
                <label
                  >Plan de mantenimiento:
                  <strong class="text-danger">*</strong></label
                >
                <app-input
                  type="file"
                  :label="
                    inputs.file_3 ? inputs.file_3.name : $t('upload_your_file')
                  "
                  v-model="inputs.file_3"
                  :required="true"
                  v-if="!inputs.maintenance_plan"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(inputs, 'maintenance_plan')"
                    v-if="inputs.maintenance_plan"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="confirmed('maintenance_plan')"
                    v-if="inputs.maintenance_plan"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label
                  >Borrador del Informe Técnico del Director de Área:
                  <strong class="text-danger">*</strong></label
                >
                <app-input
                  type="file"
                  :label="
                    inputs.file_4 ? inputs.file_4.name : $t('upload_your_file')
                  "
                  v-model="inputs.file_4"
                  :required="true"
                  v-if="!inputs.director_technical_report"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs, 'director_technical_report')
                    "
                    v-if="inputs.director_technical_report"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="
                      openDeleteModal('director_technical_report')
                    "
                    v-if="inputs.director_technical_report"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div> -->
            <div class="col-12">
              <h5>
                Los miembros de la comisión convocados, en base a la información
                proporcionada, han tomado la decisión de acreditación en esta
                etapa del proceso y la misma se detalla en el documento Informe
                Técnico de Análisis de Expediente, el cual dan por aceptado para
                continuar con el trámite respectivo.
              </h5>
            </div>
            <br />
            <div class="col-12 mt-3">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="submit"
              >
                {{ $t("save") }}
              </button>
              <br />
              <hr />
            </div>

            <div class="col-12">
              <legend>
                <small class="text-primary"
                  >Documentos adicionales para subsanar o complementar el
                  proceso</small
                >
              </legend>
            </div>
          </div>
        </div>
      </div>
      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirm"
        @cancelled="cancelled"
      />

      <director-area-modal
        v-if="isAddEditModalActive"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
      />
    </form>
    <div class="row">
      <div class="col-12">
        <div class="row mb-2" v-for="(vj, j) in additional_605" :key="j">
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
              >Tamaño máximo del archivo 8 Mb</small
            >
          </div>

          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
              :id="`filename_${j}`"
              type="text"
              v-model="vj.filename"
              placeholder="Descripcion del archivo"
              @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
              >Es necesario agregar una descripción</small
            >
          </div>
          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      inputs: {},
      docs: "",
      observation: "",
      deleteModal: false,
      selected: "",
      evaluations: [],
      additional_605: [],
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.dataInfo();
    this.dataList();
  },

  methods: {
    addFile() {
      if (this.additional_605.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.additional_605.push({
        record_id: this.$store.state.evaluatorReview.evalTestId,
        filename: null,
        file: null,
      });
    },

    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFile(j) {
      this.additional_605 = this.additional_605.filter(
        (value, index) => index != j
      );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.additional_605[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.additional_605[j], "file", null);
        this.$set(this.additional_605[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename) this.$set(this.additional_605[j], "filename", "");
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.additional_605[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    removeRowFile(j) {
      this.additional_605 = this.additional_605.filter(
        (value, index) => index != j
      );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/evaluator/decision/closureFindingsDecision/addFileAttach`;
      const tmpo = this.additional_605[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.additional_605[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.additional_605];
            tmp[j] = data;
            this.additional_605 = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    confirm() {
      const url = `/evaluator/decision/closureFindingsDecision/destroyFileAttach?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "additional_605") {
            const tmp = this.additional_605.filter(
              (value, index) => index != this.tmp.j
            );
            this.additional_605 = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    dataInfo() {
      let url = `/accreditationReview/decision/areaDirectorReport/show?accAppId=${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
        this.docs = response.data;
        this.additional_605 = response.data.additional_605;
      });
    },
    dataList() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/decisionDirectorFile/directorTechnicalReport/evaluationList/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.evaluations = response.data.evaluations;
      });
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabFor(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },

    submit() {
      this.preloader = true;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append(
        "accreditationId",
        this.$store.state.evaluatorReview.evalTestId
      );
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.preloader = false;
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    // openDeleteModal(fileName) {
    //   this.selected = fileName;
    //   this.deleteModal = true;
    // },

    confirmed(fileName) {
      this.inputs[fileName] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          evidence_member_participation:
            this.$store.state.evaluatorReview.evalTest
              .evidence_member_participation,
          technical_file_analysis_report:
            this.$store.state.evaluatorReview.evalTest
              .technical_file_analysis_report,
          maintenance_plan:
            this.$store.state.evaluatorReview.evalTest.maintenance_plan,
          director_technical_report:
            this.$store.state.evaluatorReview.evalTest.director_technical_report,
          scope605: this.$store.state.evaluatorReview.evalTest.scope605,
        };
      }
    },
  },
};
</script>